import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Page::Registries::Reclaim @registries={{this.model.registries}} @pagination={{this.model.pagination}} @linkedStatus={{this.model.linkedStatus}} />", {
  moduleName: "vagrant/templates/registries/reclaim.hbs"
});